import { LOGIN_USER, LOGOUT_USER, LOGIN_USER_ERROR, HIDE_ERROR, SET_LANG, SET_HIGH_CONTRAST} from '../constants/ActionTypes'
import { getEffectiveLang } from '../utils/LangUtils'

function resetState(){
  return {
    initDone: false,
    invalid: false,
    error_message: false,
    lang: false,
    high_contrast: localStorage.getItem('high_contrast') || false,
    session: {
      token: false,
      username: false
    }
  }
}

function setHighContrast(high_contrast){
  localStorage.setItem('high_contrast', high_contrast)
}

function destroySession(){
  localStorage.removeItem('ideaerp_token')
  localStorage.removeItem('ideaerp_username')
}

function getInitialState(){
  return {
    ...resetState(),
    lang: getEffectiveLang()
  }
}

export default function auth(state = getInitialState(), action) {
  switch (action.type) {
    case LOGIN_USER:
      return { ...state,
        lang: action.payload.lang || state.lang || getEffectiveLang(),
        invalid: false,
        error_message: false,
        session: action.payload
      }
    case LOGOUT_USER:
      destroySession()
      return { ...resetState(),
        initDone: true
      }
    case LOGIN_USER_ERROR:
      return { ...state,
        invalid: true,
        error_message: action.message || false
      }
    case HIDE_ERROR:
      return { ...state,
        invalid: false,
        error_message: false
      }
    case SET_LANG:
      return { ...state,
        lang: action.payload,
        initDone: true
      }
    case SET_HIGH_CONTRAST:
      setHighContrast(action.payload)
      return state
    default:
      return state
  }
}
